import { CatJobHistoryItem, WorkStatus } from "../../../client/types.gen";

// Which run history row offers "Re-run financials". Pure so the row rule can be
// pinned by test: a wrong answer here is silent, showing or hiding a button
// rather than erroring.
//
// Repricing a completed run emits a new batch, so it anchors on the batch
// backing the current results. Otherwise a shadow run would take the action
// from the active batch by merely being more recent.
export const canRerunFinancials = (
  job: CatJobHistoryItem,
  rerunAnchorBatchId: string | null
): boolean =>
  job.batch_id === rerunAnchorBatchId && job.status === WorkStatus.DONE;
